import { Banner } from "@newsela/angelou";
import { useState } from "react";

import { useStandardsSearchContext } from "@/search/Langston/StandardsSearchProvider";
import { IStandard } from "@/search/Langston/types/IStandard";
import { STANDARDS_SET_MODE } from "@/search/Langston/types/IStandardsSetMode";
import { useStandardsModalContext } from "../../../StandardsModalProvider";
import {
  StandardsModalCheckbox,
  StandardsModalViewMoreButton,
} from "../../shared";
import { NoStandardsFound } from "../NoStandardsFound";
import { StandardItem } from "./StandardItem";
import { bannerCss, standardsContainerCss } from "./StandardsList.styles";

interface StandardsListProps {
  standards?: IStandard[] | undefined;
  limit?:
    | {
        count: number;
        temporarySelectedIds: string[];
        setTemporarySelectedIds: (ids: string[]) => void;
      }
    | undefined;
}

export const StandardsList = ({ standards, limit }: StandardsListProps) => {
  const {
    getters: { filteredStandards, standardsSetMode },
  } = useStandardsModalContext();
  const [displayErrorBanner, setDisplayErrorBanner] = useState(false);
  const { currentNeedle, showViewMoreButton } = useStandardsSearchContext();
  const standardsList = standards || filteredStandards;

  const renderStandardsListItems = () => {
    const showModalCheckbox =
      standards || standardsSetMode === STANDARDS_SET_MODE.VIEW;
    const {
      count,
      temporarySelectedIds = [],
      setTemporarySelectedIds,
    } = limit || {};

    return (
      <ul css={standardsContainerCss} data-testid="standards-list">
        {standardsList.map((standard) =>
          showModalCheckbox ? (
            <StandardsModalCheckbox
              key={standard.id}
              standard={standard}
              disabled={
                !!count &&
                !temporarySelectedIds?.includes(standard.id) &&
                temporarySelectedIds.length >= count
              }
              temporarySelectedIds={temporarySelectedIds}
              setTemporarySelectedIds={setTemporarySelectedIds}
              setDisplayErrorBanner={setDisplayErrorBanner}
            />
          ) : (
            <StandardItem key={standard.id} standard={standard} />
          ),
        )}
      </ul>
    );
  };

  return (
    <>
      {displayErrorBanner && (
        <Banner
          __cssFor={bannerCss}
          bannerType={Banner.types.info}
          body="You can only select 3 standards for this lesson plan."
          isCenter={false}
          isDismissible
          onClose={() => setDisplayErrorBanner(false)}
        />
      )}
      {renderStandardsListItems()}
      {standardsList.length === 0 && currentNeedle !== "" && (
        <NoStandardsFound />
      )}
      {!standards && showViewMoreButton ? (
        <StandardsModalViewMoreButton />
      ) : null}
    </>
  );
};
